import { OENInputControl } from "../enums/oe-input-control.enum";
import { OENPanel } from "../enums/oe-panel.enum";
import { OENLockedState } from "../enums/oe-locked-state.enum";

export const NO_LOCKING_INPUT: OENInputControl[] = [
  OENInputControl.ACCOUNT_ACTIVE_TAB,
  OENInputControl.CLIENT_ACTIVE_TAB,
  OENInputControl.SUSPEND_FROM,
  OENInputControl.SUSPEND_TO,
];

export const BFX_PRIVATIZATION_INPUT_CONTROL: OENInputControl[] = [
  OENInputControl.CLIENT,
  OENInputControl.ACCOUNT,
  OENInputControl.CONTACT,
  OENInputControl.TRADER,
  OENInputControl.CLIENT_COMMENTS,
  OENInputControl.PRIVATE_COMMENTS,
];

export const INPUT_TO_PANEL_MAPPING = new Map<OENInputControl, OENPanel>([
  // Client
  [OENInputControl.CLIENT, OENPanel.PANEL_CLIENT],
  [OENInputControl.ACCOUNT, OENPanel.PANEL_CLIENT],
  [OENInputControl.CONTACT, OENPanel.PANEL_CLIENT],
  [OENInputControl.TRADER, OENPanel.PANEL_CLIENT],
  // Financials
  [OENInputControl.ACCOUNT_ACTIVE_TAB, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.CLIENT_ACTIVE_TAB, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.CCY_PAIR, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.ORDER_TYPE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.ALGO_TYPE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.CLIENT_INTENT, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.FIXED_CCY, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.ORDER_AMOUNT, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.REQUEST_PRICE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.TRAILING_PIPS, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.TRAILING_TRIGGER, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.VALUE_DATE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.TRIGGER, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.MARKUP, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.MARKUP_TYPE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.GOOD_FROM, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.GOOD_UNTIL, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.SUSPEND, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.SUSPEND_FROM, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.SUSPEND_TO, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.TRADER_GROUP, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.FIXING_DATE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.FIXING_SOURCE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.LIMIT_PRICE, OENPanel.PANEL_FINANCIALS],
  // Gamma
  [OENInputControl.DELTA, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.RUNGS_ABOVE, OENPanel.PANEL_FINANCIALS],
  [OENInputControl.RUNGS_BELOW, OENPanel.PANEL_FINANCIALS],
  // Algo
  [OENInputControl._ALGO_, OENPanel.PANEL_ALGO],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENPanel.PANEL_MORE],
  [OENInputControl.PRIVATE_COMMENTS, OENPanel.PANEL_MORE],
  [OENInputControl.PARTIAL_FILL, OENPanel.PANEL_MORE],
  [OENInputControl.STP_AGG, OENPanel.PANEL_MORE],
  [OENInputControl.EXECUTION_MODE, OENPanel.PANEL_MORE],
  [OENInputControl.PRIVATE_ORDER, OENPanel.PANEL_MORE],
  [OENInputControl.HOLD_STP, OENPanel.PANEL_MORE],
  [OENInputControl.AUTO_FORWARD_PRICING, OENPanel.PANEL_MORE],
  [OENInputControl.CUSTOM_FIELDS, OENPanel.PANEL_MORE],
  // Notifications
  [OENInputControl.BTN_OCO, OENPanel.PANEL_NOTIFICATIONS],
  [OENInputControl.BTN_IF_DONE, OENPanel.PANEL_NOTIFICATIONS],
  [OENInputControl.BTN_LOOP, OENPanel.PANEL_NOTIFICATIONS],
  [OENInputControl.BTN_TIMEOUT, OENPanel.PANEL_NOTIFICATIONS],
  // OBO
  [OENInputControl.OBO_CLIENT, OENPanel.PANEL_OBO],
  [OENInputControl.OBO_ACCOUNT, OENPanel.PANEL_OBO],
]);

export const NEW_ENTRY_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.UNLOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.UNLOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.UNLOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.UNLOCKED],
  [OENInputControl.TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.UNLOCKED],
  // Gamma
  [OENInputControl.DELTA, OENLockedState.UNLOCKED],
  [OENInputControl.RUNGS_ABOVE, OENLockedState.UNLOCKED],
  [OENInputControl.RUNGS_BELOW, OENLockedState.UNLOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.UNLOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.AUTO_FORWARD_PRICING, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.UNLOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.UNLOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.UNLOCKED],
]);

export const OCO_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED], // [OENInputControl.SUSPEND_FROM, OENLockedState.LOCKED], [OENInputControl.SUSPEND_TO, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

// Locking following: Client, Account, Contacts, Client Trader, Pair, Dealt Ccy, Value Date, Good From, Active From/To, Hold STP, Private, Execution, Trader Group.
export const IF_DONE_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const LOOP_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client details
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const TIMEOUT_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_PARTIAL_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const GAMMA_CUSTOMISE_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.DELTA, OENLockedState.LOCKED],
  [OENInputControl.RUNGS_ABOVE, OENLockedState.LOCKED],
  [OENInputControl.RUNGS_BELOW, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
]);

export const GAMMA_CUSTOMISE_UNLOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.UNLOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.UNLOCKED],
  [OENInputControl.TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.UNLOCKED],
  // More
  [OENInputControl.DELTA, OENLockedState.UNLOCKED],
  [OENInputControl.RUNGS_ABOVE, OENLockedState.UNLOCKED],
  [OENInputControl.RUNGS_BELOW, OENLockedState.UNLOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
]);

export const MODIFY_PARTIAL_ACTIVE_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  // More
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_FULL_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.LOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.LOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_LOOP_LOCK_ACTIVE_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_LOOP_LOCK_PASSIVE_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_ROOT_TERMINAL_ACTIVE_LEG_LOCK_MAPPING = new Map<
  OENInputControl,
  OENLockedState
>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.UNLOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.UNLOCKED],
  // Notifications
  /* 	[OENInputControl.BTN_OCO, OENLockedState.UNLOCKED],
	[OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
	[OENInputControl.BTN_LOOP, OENLockedState.UNLOCKED],
	[OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED], */
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_INFO_ACTIVE_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.LIMIT_PRICE, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.LOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.LOCKED],
  [OENInputControl.AUTO_FORWARD_PRICING, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // ALGO Params Panel
  [OENInputControl._ALGO_, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_INFO_PASSIVE_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.LIMIT_PRICE, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.LOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.LOCKED],
  [OENInputControl.AUTO_FORWARD_PRICING, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.LOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // ALGO Params Panel
  [OENInputControl._ALGO_, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const MODIFY_INFO_TERMINAL_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.LIMIT_PRICE, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.LOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.LOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.LOCKED],
  [OENInputControl.AUTO_FORWARD_PRICING, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.LOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // ALGO Params Panel
  [OENInputControl._ALGO_, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const AMEND_MARKUP_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.LOCKED],
  [OENInputControl.ALGO_TYPE, OENLockedState.LOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.LOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.LOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.LIMIT_PRICE, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.LOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.LOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.LOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.LOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.LOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.LOCKED],
  [OENInputControl.AUTO_FORWARD_PRICING, OENLockedState.LOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.LOCKED],
  [OENInputControl.STP_AGG, OENLockedState.LOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.LOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
  // ALGO Params Panel
  [OENInputControl._ALGO_, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const PRIVATIZATION_BOTH_COMMENTS_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.LOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const PRIVATIZATION_CLIENT_COMMENTS_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.LOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const PRIVATIZATION_PRIVATE_COMMENTS_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>(
  [
    // Client
    [OENInputControl.CLIENT, OENLockedState.LOCKED],
    [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
    [OENInputControl.CONTACT, OENLockedState.LOCKED],
    [OENInputControl.TRADER, OENLockedState.LOCKED],
    // More
    [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
    [OENInputControl.PRIVATE_COMMENTS, OENLockedState.LOCKED],
    // OBO
    [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
    [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
  ],
);

export const PRIVATIZATION_NO_COMMENTS_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.LOCKED],
  [OENInputControl.TRADER, OENLockedState.LOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);

export const NO_PRIVATIZATION_UNLOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.UNLOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.UNLOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.UNLOCKED],
]);

export const MKT_ORDER_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // ENTRY FORM
  [OENInputControl.GOOD_UNTIL, OENLockedState.LOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.LOCKED],
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  // Strategy buttons
  [OENInputControl.BTN_IF_DONE, OENLockedState.LOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.LOCKED],
]);

export const MKT_STRATEGY_LEG_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // ENTRY FORM
  [OENInputControl.SUSPEND, OENLockedState.LOCKED],
]);

export const BULKED_LOCK_MAPPING = new Map<OENInputControl, OENLockedState>([
  // Client
  [OENInputControl.CLIENT, OENLockedState.LOCKED],
  [OENInputControl.ACCOUNT, OENLockedState.LOCKED],
  [OENInputControl.CONTACT, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER, OENLockedState.UNLOCKED],
  // Financials
  [OENInputControl.CCY_PAIR, OENLockedState.LOCKED],
  [OENInputControl.ORDER_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.CLIENT_INTENT, OENLockedState.LOCKED],
  [OENInputControl.FIXED_CCY, OENLockedState.UNLOCKED],
  [OENInputControl.ORDER_AMOUNT, OENLockedState.UNLOCKED],
  [OENInputControl.REQUEST_PRICE, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_PIPS, OENLockedState.UNLOCKED],
  [OENInputControl.TRAILING_TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.VALUE_DATE, OENLockedState.LOCKED],
  [OENInputControl.TRIGGER, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP, OENLockedState.UNLOCKED],
  [OENInputControl.MARKUP_TYPE, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_FROM, OENLockedState.UNLOCKED],
  [OENInputControl.GOOD_UNTIL, OENLockedState.UNLOCKED],
  [OENInputControl.SUSPEND, OENLockedState.UNLOCKED],
  [OENInputControl.TRADER_GROUP, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_DATE, OENLockedState.UNLOCKED],
  [OENInputControl.FIXING_SOURCE, OENLockedState.UNLOCKED],
  // More
  [OENInputControl.CLIENT_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_COMMENTS, OENLockedState.UNLOCKED],
  [OENInputControl.EXECUTION_MODE, OENLockedState.UNLOCKED],
  [OENInputControl.PRIVATE_ORDER, OENLockedState.UNLOCKED],
  [OENInputControl.HOLD_STP, OENLockedState.UNLOCKED],
  [OENInputControl.PARTIAL_FILL, OENLockedState.UNLOCKED],
  [OENInputControl.STP_AGG, OENLockedState.UNLOCKED],
  [OENInputControl.CUSTOM_FIELDS, OENLockedState.UNLOCKED],
  // Notifications
  [OENInputControl.BTN_OCO, OENLockedState.LOCKED],
  [OENInputControl.BTN_IF_DONE, OENLockedState.UNLOCKED],
  [OENInputControl.BTN_LOOP, OENLockedState.LOCKED],
  [OENInputControl.BTN_TIMEOUT, OENLockedState.UNLOCKED],
  // OBO
  [OENInputControl.OBO_CLIENT, OENLockedState.LOCKED],
  [OENInputControl.OBO_ACCOUNT, OENLockedState.LOCKED],
]);
